
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vucW", function(module, exports) {

$parcel$export(module.exports, "NudgeBundledUsersXflow", () => $0e9969df0dc9c649$export$77e873b657cd17de);

var $5uXOq = parcelRequire("5uXOq");

var $gwejS = parcelRequire("gwejS");
var $jovBr = parcelRequire("jovBr");
var $lb7qa = parcelRequire("lb7qa");

var $jnhNB = parcelRequire("jnhNB");

var $pa9q9 = parcelRequire("pa9q9");

var $gOHSJ = parcelRequire("gOHSJ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $5GDqD = parcelRequire("5GDqD");

var $2LwjF = parcelRequire("2LwjF");

var $796kT = parcelRequire("796kT");

var $lyjFC = parcelRequire("lyjFC");

var $ayC7S = parcelRequire("ayC7S");

var $7UfZB = parcelRequire("7UfZB");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $0e9969df0dc9c649$var$CONFLUENCE_URL = `https://${window.location.hostname}/wiki/`;
const $0e9969df0dc9c649$var$END_RANGE = 31;
const $0e9969df0dc9c649$var$START_RANGE = 7;
const $0e9969df0dc9c649$var$isActive7to30DaysAgo = (accountCreationDate)=>{
    const date = new Date(accountCreationDate);
    if (!(0, $jovBr.default)(date)) return false;
    const today = new Date();
    return (0, $lb7qa.default)(today, {
        start: (0, $gwejS.default)(date, $0e9969df0dc9c649$var$START_RANGE),
        end: (0, $gwejS.default)(date, $0e9969df0dc9c649$var$END_RANGE)
    });
};
const $0e9969df0dc9c649$export$77e873b657cd17de = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const flagId = (0, $5uXOq.useRef)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const accountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [traits, { fetchTraits: fetchTraits }] = (0, $5GDqD.useTraits)();
    const [permitted, setPermitted] = (0, $5uXOq.useState)(false);
    const [state, actions] = (0, $lyjFC.useFlagDismissed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isReminderNudge = actions.canReShowFlag();
    (0, $5uXOq.useEffect)(()=>{
        fetchTraits([
            'SITE_USER'
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        accountId,
        cloudId,
        fetchTraits
    ]);
    const jiraFirstActive = (0, $2LwjF.getTraitByName)(traits, 'jira_first_active')?.value;
    const passesAgeCondition = typeof jiraFirstActive === 'string' ? $0e9969df0dc9c649$var$isActive7to30DaysAgo(jiraFirstActive) : false;
    const confluenceFirstActiveDate = (0, $2LwjF.getTraitByName)(traits, 'confluence_first_active')?.value;
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            const confluenceAccess = await (0, $796kT.checkIfUserHasPermissionToAccessConfluence)(cloudId);
            setPermitted(confluenceAccess.permitted);
        };
        if (passesAgeCondition && !confluenceFirstActiveDate) fetchData();
    }, [
        cloudId,
        confluenceFirstActiveDate,
        passesAgeCondition
    ]);
    const isEligibleUser = passesAgeCondition && // jira_first_active + 7 < today < jira_first_active + 31
    !confluenceFirstActiveDate && // should not have logged into confluence
    permitted; // should have confluence access
    const skipRecommendedUsersCall = !isEligibleUser || state.hasBeenDismissed && !isReminderNudge;
    const { loading: loading, recommendedUsers: recommendedUsers } = (0, $ayC7S.useGetRecommendedUsers)(skipRecommendedUsersCall);
    (0, $5uXOq.useEffect)(()=>{
        passesAgeCondition && !confluenceFirstActiveDate && (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'traits loaded', {
            jiraFirstActive: jiraFirstActive,
            confluenceFirstActiveDate: confluenceFirstActiveDate,
            permitted: permitted
        });
    }, [
        confluenceFirstActiveDate,
        createAnalyticsEvent,
        isEligibleUser,
        jiraFirstActive,
        passesAgeCondition,
        permitted
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleUser && flagId.current == null && !loading && (!state.hasBeenDismissed || isReminderNudge // should not have dismissed the flag (control lacks this condition)
        )) {
            flagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gOHSJ.JiraCommonFlag), {
                        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
                        id: flagId,
                        ...recommendedUsers?.length ? {
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
                                appearance: "stack",
                                data: recommendedUsers,
                                maxCount: 2
                            })
                        } : null,
                        messageId: "nudge-bundled-users-to-join-connie.ui.flag.nudge-flag",
                        messageType: "engagement",
                        testId: "nudge-bundled-users-to-join-connie.ui.nudge-flag",
                        title: formatMessage((0, $7UfZB.default).title),
                        description: formatMessage((0, $7UfZB.default).description),
                        flagType: "info",
                        isAutoDismiss: false,
                        actions: [
                            {
                                content: formatMessage((0, $7UfZB.default).joinButton),
                                onClick: ()=>{
                                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'nudgeBundledUserFlagAction', {
                                        isReminderNudge: isReminderNudge
                                    });
                                    flagId.current && dismissFlag(flagId.current);
                                    actions.dismiss();
                                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                    window.open($0e9969df0dc9c649$var$CONFLUENCE_URL, '_blank');
                                }
                            }
                        ],
                        onDismissed: ()=>{
                            if (flagId.current) {
                                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'nudgeBundledUserFlagAction', {
                                    isReminderNudge: isReminderNudge
                                });
                                dismissFlag(flagId.current);
                                actions.dismiss();
                            }
                        },
                        ...props
                    })
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag viewed', 'nudgeBundledUserFlag', {
                isReminderNudge: isReminderNudge
            });
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        formatMessage,
        showFlag,
        isReminderNudge,
        actions,
        isEligibleUser,
        recommendedUsers,
        loading,
        state.hasBeenDismissed
    ]);
    return null;
};

});
parcelRegister("jnhNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $90dd6416d3b8b9cd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $ujWmd = parcelRequire("ujWmd");


var $eGmKJ = parcelRequire("eGmKJ");

var $fsuMn = parcelRequire("fsuMn");

var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $9Prrp = parcelRequire("9Prrp");

var $8APWV = parcelRequire("8APWV");

var $ibUQm = parcelRequire("ibUQm");

var $6tB70 = parcelRequire("6tB70");

var $3PuF6 = parcelRequire("3PuF6");

var $lFwF6 = parcelRequire("lFwF6");

var $4VtSA = parcelRequire("4VtSA");
const $90dd6416d3b8b9cd$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $90dd6416d3b8b9cd$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $4VtSA.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $4VtSA.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $90dd6416d3b8b9cd$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $ujWmd.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $5uXOq.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $fsuMn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $eGmKJ.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $eGmKJ.default;
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$90dd6416d3b8b9cd$var$getOverrides(overrides).MoreIndicator.render((0, $3PuF6.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ibUQm.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6tB70.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                            children: data.slice(max).map((avatar, index)=>$90dd6416d3b8b9cd$var$getOverrides(overrides).AvatarGroupItem.render((0, $9Prrp.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $90dd6416d3b8b9cd$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $lFwF6.default) : (0, $8APWV.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $90dd6416d3b8b9cd$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $4VtSA.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total)
        ]
    });
};
var $90dd6416d3b8b9cd$export$2e2bcd8739ae039 = $90dd6416d3b8b9cd$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $5e71d9a7b5ef77ee$export$390330c10ff2b9a1 = 'ArrowUp';
const $5e71d9a7b5ef77ee$export$a80636c6f41931fe = 'ArrowDown';
const $5e71d9a7b5ef77ee$export$4af703091671bc = 'Home';
const $5e71d9a7b5ef77ee$export$e2bc30913faa5db7 = 'End';
const $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b = 'Tab';
const $5e71d9a7b5ef77ee$export$8152f929a25a0ff4 = 'Enter';
const $5e71d9a7b5ef77ee$export$e51a3576c045c8d5 = 'Space';
const $5e71d9a7b5ef77ee$export$2bb790b9008907b4 = 'Escape';

parcelRegister("9Prrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $70f7ee1b8d27f0de$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $5JjdN = parcelRequire("5JjdN");

var $kJpBP = parcelRequire("kJpBP");
var $1aogK = parcelRequire("1aogK");
var $3Z96c = parcelRequire("3Z96c");

var $kiqun = parcelRequire("kiqun");
const $70f7ee1b8d27f0de$var$AvatarGroupItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $kiqun.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70f7ee1b8d27f0de$export$2e2bcd8739ae039 = $70f7ee1b8d27f0de$var$AvatarGroupItem;

});
parcelRegister("kiqun", function(module, exports) {

$parcel$export(module.exports, "default", () => $7253832d56a8089b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ibUQm = parcelRequire("ibUQm");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $7253832d56a8089b$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $ibUQm.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $7253832d56a8089b$export$2e2bcd8739ae039 = $7253832d56a8089b$var$useRegisterItemWithFocusManager;

});
parcelRegister("ibUQm", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $55ca5414cf1fda71$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $55ca5414cf1fda71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $kmker = parcelRequire("kmker");
const $55ca5414cf1fda71$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $eGmKJ.default)
});
/**
 * Focus manager logic
 */ const $55ca5414cf1fda71$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $5uXOq.useEffect)(()=>{
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $kmker.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: (0, $kmker.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($55ca5414cf1fda71$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $55ca5414cf1fda71$export$2e2bcd8739ae039 = $55ca5414cf1fda71$var$FocusManager;

});
parcelRegister("kmker", function(module, exports) {

$parcel$export(module.exports, "default", () => $3817c9dabf013561$export$2e2bcd8739ae039);

const $3817c9dabf013561$var$actionMap = {
    [(0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)]: 'next',
    [(0, $5e71d9a7b5ef77ee$export$390330c10ff2b9a1)]: 'prev',
    [(0, $5e71d9a7b5ef77ee$export$4af703091671bc)]: 'first',
    [(0, $5e71d9a7b5ef77ee$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $3817c9dabf013561$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $3817c9dabf013561$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $3817c9dabf013561$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $3817c9dabf013561$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $3817c9dabf013561$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $3817c9dabf013561$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $3817c9dabf013561$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $3817c9dabf013561$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("8APWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb6c6550ac6ffd68$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $fb6c6550ac6ffd68$var$gutter = "var(--ds-space-negative-050, -4px)";
const $fb6c6550ac6ffd68$var$listStyles = null;
const $fb6c6550ac6ffd68$var$listItemStyles = null;
const $fb6c6550ac6ffd68$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb6c6550ac6ffd68$export$2e2bcd8739ae039 = $fb6c6550ac6ffd68$var$Grid;

});

parcelRegister("6tB70", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f8303bf50b0794$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $ibUQm = parcelRequire("ibUQm");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $76f8303bf50b0794$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $ibUQm.FocusManagerContext));
    (0, $5uXOq.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZUJu.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $76f8303bf50b0794$export$2e2bcd8739ae039 = $76f8303bf50b0794$var$PopupAvatarGroup;

});

parcelRegister("3PuF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $107bc22aecddc7e7$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $107bc22aecddc7e7$var$boxShadowCssVar = '--avatar-box-shadow';
const $107bc22aecddc7e7$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $107bc22aecddc7e7$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $107bc22aecddc7e7$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $107bc22aecddc7e7$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT = 99;
const $107bc22aecddc7e7$var$MoreIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'circle', borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
borderColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT ? $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$107bc22aecddc7e7$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $bwpsq.default)([
            $107bc22aecddc7e7$var$styles.root,
            $107bc22aecddc7e7$var$borderRadiusMap[size],
            appearance === 'circle' && $107bc22aecddc7e7$var$styles.circle,
            $107bc22aecddc7e7$var$widthHeightMap[size],
            $107bc22aecddc7e7$var$fontMap[size],
            isActive && $107bc22aecddc7e7$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$107bc22aecddc7e7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$107bc22aecddc7e7$export$2e2bcd8739ae039 = $107bc22aecddc7e7$var$MoreIndicator;

});

parcelRegister("lFwF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bab9e2cbf400fcb$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7bab9e2cbf400fcb$var$listStyles = null;
const $7bab9e2cbf400fcb$var$listItemStyles = null;
const $7bab9e2cbf400fcb$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7bab9e2cbf400fcb$export$2e2bcd8739ae039 = $7bab9e2cbf400fcb$var$Stack;

});

parcelRegister("4VtSA", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $71c6d3b80b1d879f$export$b067756944994c79);
const $71c6d3b80b1d879f$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("gOHSJ", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => $8f9a85e85178b852$export$1d9a3324fc0eb52);

var $5uXOq = parcelRequire("5uXOq");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $59YvY = parcelRequire("59YvY");

var $6TwEp = parcelRequire("6TwEp");
const $8f9a85e85178b852$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59YvY.ChoreographerCommonFlag), props);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6TwEp.default), rest);
};

});
parcelRegister("59YvY", function(module, exports) {

$parcel$export(module.exports, "ChoreographerCommonFlag", () => $3f981fa4d7c05e5a$export$ef12cdd486f28a7a);

var $cSWNW = parcelRequire("cSWNW");

var $6TwEp = parcelRequire("6TwEp");
const $3f981fa4d7c05e5a$export$ef12cdd486f28a7a = (0, $cSWNW.withChoreographedRender)((0, $6TwEp.default));

});
parcelRegister("6TwEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb99bb14be92466$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6pLjz = parcelRequire("6pLjz");

var $7fDjk = parcelRequire("7fDjk");
const $ffb99bb14be92466$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
// standard delay time in ms, added for SR users to announce the status flag
const $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY = 2500;
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $ffb99bb14be92466$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement = $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY, isAutoDismiss: isAutoDismiss, ...flagProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const StyledIcon = flagProps.appearance ? (0, $6pLjz.boldIconMap)[flagType] : (0, $6pLjz.iconMap)[flagType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ffb99bb14be92466$var$containerStyles,
        ...flagProps.testId && {
            'data-test-id': flagProps.testId
        }
    }, isAutoDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWXJB.default), {
        testId: `${$ffb99bb14be92466$export$b020578ce674a70f}-auto-dismiss`,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epfFv.default), {
        testId: $ffb99bb14be92466$export$b020578ce674a70f,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }));
};
var $ffb99bb14be92466$export$2e2bcd8739ae039 = $ffb99bb14be92466$var$CommonFlag;
const $ffb99bb14be92466$var$containerStyles = (0, $8CUq3.xcss)({
    wordWrap: 'break-word'
});

});
parcelRegister("6pLjz", function(module, exports) {

$parcel$export(module.exports, "iconMap", () => $38acb16b2f8a5dd3$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $38acb16b2f8a5dd3$export$6c71c95b1e390472);

var $jEF9d = parcelRequire("jEF9d");
const $38acb16b2f8a5dd3$export$6d49a893c897b0cc = {
    error: (0, $jEF9d.IconError),
    success: (0, $jEF9d.IconSuccess),
    info: (0, $jEF9d.IconInfo),
    warning: (0, $jEF9d.IconWarning)
};
const $38acb16b2f8a5dd3$export$6c71c95b1e390472 = {
    error: (0, $jEF9d.BoldIconError),
    success: (0, $jEF9d.BoldIconSuccess),
    info: (0, $jEF9d.BoldIconInfo),
    warning: (0, $jEF9d.BoldIconWarning)
};

});
parcelRegister("jEF9d", function(module, exports) {

$parcel$export(module.exports, "IconError", () => $29d87fe42743cbe5$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $29d87fe42743cbe5$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $29d87fe42743cbe5$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $29d87fe42743cbe5$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $29d87fe42743cbe5$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $29d87fe42743cbe5$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $29d87fe42743cbe5$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $29d87fe42743cbe5$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c2i4s = parcelRequire("c2i4s");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");
const $29d87fe42743cbe5$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-danger, #C9372C)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-success, #22A06B)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-discovery, #8270DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-warning, #E56910)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-danger, #C9372C)"
    });
const $29d87fe42743cbe5$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-success, #22A06B)"
    });
const $29d87fe42743cbe5$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-discovery, #8270DB)"
    });
const $29d87fe42743cbe5$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-warning, #E56910)"
    });
const $29d87fe42743cbe5$export$8f314e512d92575f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $lD23V.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7fDjk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $de522aa55d5b135d$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file

var $7VHMR = parcelRequire("7VHMR");
const $de522aa55d5b135d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});




parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $5e4cf08f88a8a143$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $5e4cf08f88a8a143$export$e653f602b87eec56);

var $eusud = parcelRequire("eusud");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $jX0pr = parcelRequire("jX0pr");

var $8ilPk = parcelRequire("8ilPk");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $13UaH.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $jX0pr.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $13UaH.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $iXqE5.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $3sQ5x.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $6dDSs.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $2LwjF.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitValue)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $a4882989c0079311$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $a4882989c0079311$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $a4882989c0079311$export$da1e8ce191f01409);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $a4882989c0079311$export$252a469687875173(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $a4882989c0079311$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $a4882989c0079311$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("796kT", function(module, exports) {

$parcel$export(module.exports, "checkIfUserHasPermissionToAccessConfluence", () => $7d0e91034555a132$export$fe9cdfed60649389);

var $7f4tk = parcelRequire("7f4tk");
const $7d0e91034555a132$export$fe9cdfed60649389 = async (cloudId)=>{
    const response = await (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("lyjFC", function(module, exports) {

$parcel$export(module.exports, "useFlagDismissed", () => $7774ed11de7c2539$export$d86ee142b28d8c2f);

var $5uXOq = parcelRequire("5uXOq");

var $gwejS = parcelRequire("gwejS");
var $79nXx = parcelRequire("79nXx");

var $bSSG7 = parcelRequire("bSSG7");
const $7774ed11de7c2539$var$LOCAL_STORAGE_NAMESPACE = 'nudge-bundle-users';
const $7774ed11de7c2539$var$storage = (0, $bSSG7.createLocalStorageProvider)($7774ed11de7c2539$var$LOCAL_STORAGE_NAMESPACE);
const $7774ed11de7c2539$var$storageKey = 'flag-dismissed';
const $7774ed11de7c2539$var$ADD_DAYS = 14;
const $7774ed11de7c2539$export$d86ee142b28d8c2f = ()=>{
    const [hasBeenDismissed, setHasBeenDismissed] = (0, $5uXOq.useState)(Boolean($7774ed11de7c2539$var$storage.get($7774ed11de7c2539$var$storageKey)));
    const dismiss = (0, $5uXOq.useCallback)(()=>{
        setHasBeenDismissed(true);
        $7774ed11de7c2539$var$storage.set($7774ed11de7c2539$var$storageKey, Date.now());
    }, [
        setHasBeenDismissed
    ]);
    const canReShowFlag = (0, $5uXOq.useCallback)(()=>{
        let canShowFlag = false;
        if (hasBeenDismissed) {
            const dismissDate = $7774ed11de7c2539$var$storage.get($7774ed11de7c2539$var$storageKey);
            if ((0, $79nXx.default)(Date.now(), (0, $gwejS.default)(dismissDate, $7774ed11de7c2539$var$ADD_DAYS))) canShowFlag = true;
        }
        return canShowFlag;
    }, [
        hasBeenDismissed
    ]);
    return [
        {
            hasBeenDismissed: hasBeenDismissed
        },
        {
            dismiss: dismiss,
            canReShowFlag: canReShowFlag
        }
    ];
};

});

parcelRegister("ayC7S", function(module, exports) {

$parcel$export(module.exports, "useGetRecommendedUsers", () => $42d50853fb7c9725$export$6e3f02729062237b);

var $5uXOq = parcelRequire("5uXOq");

var $7f4tk = parcelRequire("7f4tk");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $42d50853fb7c9725$export$6e3f02729062237b = (skip)=>{
    const accountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [data, setData] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const searchQuery = {
            context: {
                contextType: 'Generic',
                principalId: accountId,
                siteId: cloudId,
                productKey: 'jira'
            },
            searchQuery: {
                queryString: '',
                customQuery: '',
                minimumAccessLevel: 'SITE'
            },
            maxNumberOfResults: 2
        };
        const getRecommendedUser = async ()=>{
            try {
                const response = await (0, $7f4tk.default)('/gateway/api/v1/recommendations', {
                    method: 'POST',
                    body: JSON.stringify(searchQuery),
                    headers: {
                        Accept: 'application/json'
                    }
                });
                const mappedUsers = response.recommendedUsers?.map(({ id: id, name: name, avatarUrl: avatarUrl })=>({
                        key: id,
                        name: name,
                        href: '#',
                        src: avatarUrl
                    }));
                setData({
                    recommendedUsers: mappedUsers,
                    errors: response.errors
                });
            } catch (error) {
                setData({
                    errors: [
                        error
                    ],
                    recommendedUsers: []
                });
            } finally{
                setLoading(false);
            }
        };
        if (!skip) getRecommendedUser();
    }, [
        accountId,
        skip,
        cloudId
    ]);
    return {
        errors: data?.errors,
        recommendedUsers: data?.recommendedUsers,
        loading: skip ? false : loading
    };
};

});

parcelRegister("7UfZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3904dec9cf6f9344$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3904dec9cf6f9344$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "nudge-bundled-users-to-join-connie.title",
        "defaultMessage": "Your team is working in Confluence"
    },
    description: {
        "id": "nudge-bundled-users-to-join-connie.description",
        "defaultMessage": "Don\u2019t miss out on the conversations happening between your collaborators!"
    },
    joinButton: {
        "id": "nudge-bundled-users-to-join-connie.join-button",
        "defaultMessage": "Access Confluence for free"
    }
});

});



//# sourceMappingURL=async-nudge-bundled-users-flag.8805e714.js.map
